import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MessageSquare, Pin } from 'lucide-react';
import { chatAPI } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function MyDiscussionsPage() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && !user) navigate('/auth');
  }, [user, authLoading, navigate]);

  useEffect(() => {
    chatAPI.myTopics()
      .then(r => setTopics(r.data.topics || r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] pt-16 page-enter" data-testid="my-discussions-page">
      <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
        <h1 className="text-3xl font-black uppercase tracking-tight text-white mb-8" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          My Discussions
        </h1>

        {loading ? (
          <div className="space-y-4">{[1, 2, 3].map(i => <div key={i} className="skeleton h-20 rounded-xl" />)}</div>
        ) : topics.length === 0 ? (
          <div className="text-center py-16 border border-dashed border-gray-800 rounded-xl">
            <MessageSquare className="w-10 h-10 text-gray-700 mx-auto mb-3" />
            <p className="text-gray-500 text-sm">You haven't started any discussions yet.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {topics.map(topic => (
              <Link
                key={topic.id}
                to={`/events/${topic.event_id}`}
                className="block bg-[#0A0A0A] border border-gray-800 rounded-xl p-5 hover:border-gray-700 transition-colors"
                data-testid={`my-topic-${topic.id}`}
              >
                <div className="flex items-center gap-2 mb-1">
                  {topic.is_pinned && <Pin size={12} className="text-yellow-400" fill="currentColor" />}
                  <h3 className="text-white font-bold text-sm">{topic.title}</h3>
                </div>
                <p className="text-gray-500 text-xs">{topic.events?.title} · {topic.created_at?.slice(0, 10)}</p>
                <p className="text-gray-600 text-xs mt-1">{topic.reply_count || 0} replies</p>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
